import React, {useContext} from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../config/AuthContext";
import Login from "../newView/Login";
import {Content} from "antd/es/layout/layout";
import {Layout} from "antd";
import AppFooter from "./components/AppFooter";
import AppDatabaseRoutes from "./routes/AppDatabaseRoutes";
import AppHeader from "./bbdd/components/AppHeader";
import AppBreadcrumb from "./bbdd/components/AppBreadcrumb";

const Database = () => {
    const {isLoggedIn, userId, user} = useContext(AuthContext);
    const location = useLocation();

    if (isLoggedIn) {
        // Pestaña completa para el IDE (como en IdeExamFrameV2), sin header ni breadcrumb ni footer
        if (location.pathname.includes('/ide/frame')) {
            return <AppDatabaseRoutes />;
        }

        return (
            <>
                <Layout style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
                    <AppHeader/>
                    <Content style={{padding: '0 48px', flex: '1 0 auto'}}>
                        <AppBreadcrumb/>
                        <Layout style={{padding: '24px 0', background: '#fff', borderRadius: '8px'}}>
                            <AppDatabaseRoutes/>
                        </Layout>
                    </Content>
                    <AppFooter/>
                </Layout>
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};

export default Database;
